@if (gallerySalesDataLoaded) {
  <div class="">
    <div class="row mt-2 ">
      <div class="col-3 duration" style="margin-left: 10px;">
        <p-dropdown [options]="GalleryProductSalesDuration" [(ngModel)]="selectedGalleryProductSalesDuration"
          [showClear]="false" [placeholder]="'galleryInsightsCharts.selectSalesDuration' | transloco"
        (onChange)="onSalesDurationChange($event)"></p-dropdown>
      </div>
      <div class="col-9">
      </div>
      <div class="class fw-semibold mt-3 " style="margin-left: 10px;">
        @if (insightsSeriesData.SeriesName == 'Total Sales Revenue') {
          {{insightsSeriesData.SeriesName}}: {{ calculateTotalSales()  | currency:'USD':'symbol':'1.2-2' }}
        }
        @if (insightsSeriesData.SeriesName == 'Total Product Sold') {
          {{insightsSeriesData.SeriesName}}: {{ calculateTotalSales()}}
        }
      </div>
    </div>
    <div class="p-1">
      <p-chart id="{{selectedTabIndex}}" type="line" height="330px" [data]="insightsGalleryChartData" [options]="insightsSeriesChartOptions"></p-chart>
    </div>
  </div>
}